import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    GET_DOWNLOAD_CLE_EXT_TEMPLATE,
    GET_DOWNLOAD_CLE_TEMPLATE,
    GET_UPLOAD_CLE_TEMPLATE
} from '@shared-models/common.models';


@Injectable({
    providedIn: 'root'
})
export class BulkCleUploadService {
    constructor(
        private httpClient: HttpClient,
        @Optional() @Inject(GET_DOWNLOAD_CLE_TEMPLATE) private downloadCleTemplate: string,
        @Optional() @Inject(GET_DOWNLOAD_CLE_EXT_TEMPLATE) private downloadCleExtTemplate: string,
        @Optional() @Inject(GET_UPLOAD_CLE_TEMPLATE) private uploadCleTemplate: string
    ) {
    }


    downloadBulkTemplate(isExtension: boolean): Observable<any> {
        let url: string;
        if (isExtension) {
            url = this.downloadCleExtTemplate;
        }
        else {
            url = this.downloadCleTemplate;
        }


        return this.httpClient.get<unknown>(url, {
            responseType: 'blob' as 'json',
            observe: 'response',
        });
    }

    uploadFile(isExtension: boolean, file: FormData): Observable<unknown> {
            return this.httpClient.post<unknown>(this.uploadCleTemplate +'/' + isExtension, file);
    }

}
